<template>
  <div class="comp-container">
    <gamblePopComp
      boxType="title"
      :title="getDict(301)"
      :show="true"
      @close="close"
    >
      <div class="channel-list" key="share">
        <div class="channel line" @click="share({ key: 'line' })">
          <!-- line -->
        </div>
        <div class="channel twitter" @click="share({ key: 'twitter' })">
          <!-- twitter -->
        </div>
      </div>
    </gamblePopComp>
  </div>
</template>

<script>
import {
  getDict,
  serverApi,
  axios,
  webSocket,
  invokeNative,
} from "../../../../common";
import { mapState, mapGetters } from "vuex";
import gamblePopComp from "./../gamble-pop-comp";
import store from "@/store";

export default {
  name: "sharePopComp",
  props: {
    rightBtnNameList: {},
  },
  data() {
    return {
      descText: "",
      shareId: "",
    };
  },
  computed: {
    ...mapGetters(["gambleUserInfo", "gambleTaskList"]),
  },
  watch: {},
  methods: {
    getDict,
    close() {
      this.$emit("close");
    },
    share(channel) {
      this.shareLinkDone().then(() => {
        let twitterShareText = this.descText;
        let shareUrl = `${location.protocol}//${location.host}/share-page/html/${
          this.shareId || "index.html"
        }`;
        // shareUrl = `https://live.knivesout.jp/share-page/index.html`;

        if (!this.descText) {
          shareUrl = `${location.protocol}//${location.host}/share-page/index.html`;
          twitterShareText =
            "私と一緒に予想のエリートになりませんか？ただいま2021荒野ELITE LEAGUE観戦予想イベントに参加しています！試合結果を予想して、大量アイテムを無料で勝ち取れます！#KEL #荒野行動 #観戦予想";
        }
        invokeNative(
          "OnClickShareLink",
          {
            share_text: channel.key == "twitter" ? twitterShareText : "",
            share_image: "",
            share_link: `${shareUrl}?role_id=${encodeURIComponent(
              this.gambleUserInfo.uid
            )}`,
            channel: channel.key,
          },
          (res) => {
            // 执行成功
          },
          (res) => {
            //执行失败
          }
        );
      });

      //https://g83-game-center-test.game.netease.com/share-page/index.html
    },

    async shareLinkDone() {
      try {
        await serverApi.post("share_link", {});
      } catch (e) {}

      store.dispatch("gambleGetTaskList");
      store.dispatch("gambleGetUserInfo");
    },
    async getSharePageData() {
      let result = await axios.get(`/api/getSharePageData`);
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;
          let { title, subTitle, descText, pcBgImg, shareImg, shareId } = data;
          this.descText = descText || "";
          this.shareId = shareId;
        }
      }
    },
  },
  components: {
    gamblePopComp,
  },
  mounted() {},
  created() {
    this.getSharePageData();
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  width: 0;
  height: 0;
}
.channel-list {
  display: flex;
  justify-content: center;

  .channel {
    margin: 0.4rem;
    color: #fff;
    $size: 1rem;
    width: $size;
    height: $size;
    background: no-repeat;
    background-size: 100% 100%;

    &.line {
      background-image: url(./imgs/line.png);
    }
    &.twitter {
      background-image: url(./imgs/twitter.png);
    }
  }
}
</style>
